module.exports = __webpack_public_path__ + "img/y-189.81fcc199.png";